var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOmrSymbol = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 923,
    height: 480,
    viewBox: "0 0 923 480",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12344_5579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.559 478.801H283.699C325.639 478.791 367.629 478.801 409.559 478.801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.01 236.091L862.67 332.041L529.43 331.971C554.77 347.591 581.5 361.981 609.57 372.201C616.69 374.781 639.59 382.911 645.81 382.911H825.11L768.17 479.291C755.53 479.991 116.56 478.961 12.98 478.801C7.2 478.801 3.09 478.801 0.85 478.801H0L55.44 382.921H399.07C399.19 382.921 372.69 349.141 360.61 331.981L95.91 331.491L152.34 236.101H325.65C324.85 174.511 341.69 114.771 375.18 63.4006C407.01 14.6006 438.38 -11.7694 500.23 5.12063C541.53 16.4106 578.75 44.8506 607.88 75.3306L571.38 218.121C569.61 218.481 558.8 205.241 554.43 200.621C516.8 160.811 452.06 109.741 393.9 134.051C379.55 140.051 364.43 153.191 363.88 169.961C363.15 192.571 390.9 219.391 404.57 235.601L922.01 236.101V236.091Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12344_5579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 922.01,
    height: 479.53,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOmrSymbol, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Omr_symbol.77d7db37.svg";
export { ForwardRef as ReactComponent };